import { Translate } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import useTranslation, { arrayOfSupportedLanguages } from 'hooks/useTranslation/useTranslation';
import React from 'react';

interface LanguageMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}

const LanguageMenu = ({ anchorEl, open, onOpen, onClose }: LanguageMenuProps) => {
  const { translation, getLanguage, savePreferredLanguageInCache } = useTranslation();
  const selectedLanguage = getLanguage();

  return (
    <>
      <IconButton
        color="inherit"
        id="appbar-language"
        title={translation.language}
        aria-haspopup="true"
        aria-controls={open ? 'appbar-language-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={onOpen}
      >
        <Translate />
      </IconButton>
      <Menu
        id="appbar-language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        {arrayOfSupportedLanguages.map((supportedLanguage) => (
          <MenuItem
            key={supportedLanguage.value}
            id={`${supportedLanguage.label.toLowerCase()}-menu-item`}
            value={supportedLanguage.value}
            selected={selectedLanguage === supportedLanguage.value}
            disabled={selectedLanguage === supportedLanguage.value}
            onClick={() => savePreferredLanguageInCache(supportedLanguage.value)}
          >
            {supportedLanguage.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageMenu;
